import request from '@/utils/request'

// 分页查询违约记录信息
export function getPageList(params) {
  return request({
    url: '/hrApi/breakRecord',
    method: 'get',
    params: params
  })
}

// 获取违约记录列表
export function getList(params) {
  return request({
    url: '/hrApi/breakRecord/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑违约记录
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/breakRecord',
    method: 'post',
    data: data
  })
}

// 删除违约记录
export function deleteData(id) {
  return request({
    url: '/hrApi/breakRecord/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/breakRecord.js